import { createSlice } from '@reduxjs/toolkit';

const appSlice = createSlice({
  name: 'app',
  initialState: {
    lastSocketEvent: null,
  },
  reducers: {
      socketEventReceived(state, action) {
      state.lastSocketEvent = action.payload;
    },
  },
});

export const { socketEventReceived } = appSlice.actions;
export const selectSocketEvent = (state) => state.app.lastSocketEvent;
export default appSlice.reducer;